import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useAxios } from "../../../api/axios";
import { useSFToken } from "../auth/useSFToken";

export const useSalesInstruction = (sfid: string) => {
  const { t } = useTranslation();
  const axios = useAxios("salesforceApi");
  const urlKey = t("salesforce-instructions-api");
  const { data, refetch, isLoading } = useSFToken();
  const Query = useQuery({
    queryKey: ["salesforce-instructions", sfid], // Include searchInvester in queryKey to refetch when it changes
    queryFn: async () => {
      try {
        if (isLoading || !data || !sfid) return null;
        if (sfid) {
          const res = await axios.get(`${urlKey}${sfid}`);
          return res?.data;
        } else {
          return null;
        }
      } catch (error: any) {
        if (error.response && error.response.status === 401) {
          refetch();
        }
      }
    },
    enabled: !!sfid && !!localStorage.getItem("salesforceAccessToken"),
    staleTime: 0,
    refetchOnMount: true,
    refetchOnWindowFocus: true
  });

  return Query;
};
